/* eslint-disable no-console */
export class Console {
  // any matches console.log's native signature to accept heterogeneous values
  static log(message?: any, ...optionalParams: any[]) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-restricted-syntax -- this file is the designated dev-only console wrapper; direct console.log is intentional here
      console.log(message, ...optionalParams);
    }
  }
}